import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/auth/Login'
import Register from '../view/auth/Register'
import ResetPwd from '../view/auth/ResetPwd.vue'
import Home from '../view/Home'
// 安装路由
Vue.use(VueRouter);

// 配置导出路由
const router = new VueRouter({
  routes: [{
    path: "/",
    redirect: "/login"
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
  {
    name: "Register",
    path: '/register',
    component: Register
  },
    {
    name: "ResetPwd",
    path: '/password/reset',
    component: ResetPwd
  },
  {
    name: "Home",
    path: '/home',
    component: Home,
    children: [
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/im/Chat"),
      },
      {
        name: "Friend",
        path: "/home/friend",
        component: () => import("../view/im/Friend"),
      },
      {
        name: "Group",
        path: "/home/group",
        component: () => import("../view/im/Group"),
      },
      {
        name: "Workbench",
        path: "/home/workbench",
        component: () => import("../view/workbench/Workbench"),
      },
      {
        name: "EmployeeManage",
        path: "/home/employee-manage",
        component: () => import("../view/workbench/system/EmployeeManage"),
      },
      {
        name: "RoleManage",
        path: "/home/role-manage",
        component: () => import("../view/workbench/system/RoleManage"),
      },
      {
        name: "PermissionConfig",
        path: "/home/permission-config",
        component: () => import("../view/workbench/system/PermissionConfig"),
      },
      {
        name: "Setting",
        path: "/home/setting",
        component: () => import("../view/Setting"),
      },
      {
        name: "Search",
        path: "/home/search",
        component: () => import("../view/Search"),
      },
      {
        name: "CheckinStats",
        path: "/home/checkin-stats",
        component: () => import("../view/workbench/checkin/CheckinStats"),
      },
      {
        name: "CheckinReport",
        path: "/home/checkin-report",
        component: () => import("../view/workbench/checkin/CheckinReport"),
      },
      {
        name: "LeaveApproval",
        path: "/home/leave-approval",
        component: () => import("../view/workbench/checkin/LeaveApproval"),
      },
      {
        name: "MakeupApproval",
        path: "/home/makeup-approval",
        component: () => import("../view/workbench/checkin/MakeupApproval"),
      },
      {
        name: "CustomerManage",
        path: "/home/customer-manage",
        component: () => import("../view/workbench/business/CustomerManage"),
      },
      {
        name: "DriverTaskManage",
        path: "/home/driver-task-manage",
        component: () => import("../view/workbench/business/DriverTaskManage"),
      },
      {
        name: "StudentManage",
        path: "/home/student-manage",
        component: () => import("../view/workbench/business/StudentManage"),
      },
      {
        name: "CoachManage",
        path: "/home/coach-manage",
        component: () => import("../view/workbench/business/CoachManage"),
      }
    ]
  }
]
});

export default router;